import React, { Component,Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import Select from 'react-select';

const required = value => {
    if (!value) {
      return (
        <div className="alert alert-danger" role="alert">
          Este campo es obligatorio!
        </div>
      );
    }
  };

export class Ver_add_customer_cluster extends Component {
    constructor(props) {
        super(props);
        this.handleRegister = this.handleRegister.bind(this);
        this.onChangeClusterName = this.onChangeClusterName.bind(this);
        this.onChangeClusterCode = this.onChangeClusterCode.bind(this);
        this.handleUsersChange = this.handleUsersChange.bind(this);

        this.state = {
            cluster_name: "",
            cluster_code: "",
            selectedUsers: [],
            allUsers: [],
            errors: {},
            loading: false,
        }
    }

    componentWillMount() {
        this.getDataAllUsers();
    }

    getDataAllUsers(){
        var user = AuthService.getCurrentUser();
        ApiService.getConfirmUsers(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    const users = res.data.map(function(row) {
                        return {
                            value: row.id,
                            label: row.name + ' ' + row.last_name + (row.Profile && row.Profile.cell_phonenumber ? ' - ' + row.Profile.cell_phonenumber : '')
                        }
                    });
                    this.setState({ allUsers: users });
                }
            },
            error => {
            }
        );
    }

    handleUsersChange = (selectedOptions) => {
        this.setState({ selectedUsers: selectedOptions || [] });
    };

    onChangeClusterName(e) {
        this.setState({
            cluster_name: e.target.value
        });
      }

      onChangeClusterCode(e) {
        this.setState({
            cluster_code: e.target.value
        });
      }

      handleRegister(e) {
        e.preventDefault();

        this.form.validateAll();

        if (this.checkBtn.context._errors.length === 0) {
            this.setState({
                message: "",
                loading: true
              });
            var user = AuthService.getCurrentUser();
            let data_cluster = {
                'cluster_name': this.state.cluster_name,
                'cluster_code': this.state.cluster_code,
            }

            ApiService.postCustomerCluster(user.token, data_cluster).then(
            (res) => {
                if(res){
                    if(res.status == 'success')
                    {
                        // Si hay usuarios seleccionados, asignarlos al cluster
                        if(this.state.selectedUsers && this.state.selectedUsers.length > 0){
                            this.assignUsersToCluster(res.data.id);
                        } else {
                            this.props.history.push("/customer-clusters");
                            toast.success("Grupo creado!");
                        }
                    }
                    else
                    {
                        toast.error(res.message);
                        this.setState({
                            loading: false
                        });
                    }
                }else{
                    this.setState({
                        loading: false
                    });
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
              this.setState({
                loading: false
              });
              toast.error("Ha ocurrido un error!");
            }
          );
        }
      }

      assignUsersToCluster(clusterId) {
        var user = AuthService.getCurrentUser();
        let assignedCount = 0;
        let errorCount = 0;
        const totalUsers = this.state.selectedUsers.length;

        // Asignar cada usuario al cluster
        this.state.selectedUsers.forEach((selectedUser, index) => {
            let data = {
                id_user: selectedUser.value,
                id_cluster: clusterId
            };

            ApiService.assignUserToCluster(user.token, data).then(
                (res) => {
                    if(res && res.status == 'success'){
                        assignedCount++;
                    } else {
                        errorCount++;
                    }

                    // Cuando terminen todas las asignaciones
                    if(assignedCount + errorCount === totalUsers){
                        this.setState({ loading: false });
                        if(assignedCount > 0){
                            this.props.history.push("/customer-clusters");
                            toast.success(`Grupo creado con ${assignedCount} usuario(s) asignado(s)!`);
                        }
                        if(errorCount > 0){
                            toast.warning(`${errorCount} usuario(s) no pudieron ser asignados.`);
                        }
                    }
                },
                error => {
                    errorCount++;
                    if(assignedCount + errorCount === totalUsers){
                        this.setState({ loading: false });
                        if(assignedCount > 0){
                            this.props.history.push("/customer-clusters");
                            toast.success(`Grupo creado con ${assignedCount} usuario(s) asignado(s)!`);
                        }
                        if(errorCount > 0){
                            toast.warning(`${errorCount} usuario(s) no pudieron ser asignados.`);
                        }
                    }
                }
            );
        });
      }

    render() {
        return (
            <Fragment>
                <Breadcrumb title="Añadir Grupo de Clientes" parent="Promociones" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Añadir Grupo de Clientes</h5>
                                </div>
                                <div className="card-body">
                                <Form
                                    onSubmit={this.handleRegister}
                                    ref={c => {
                                        this.form = c;
                                    }}
                                >
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Nombre del Grupo</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="text"
                                                className="form-control"
                                                name="cluster_name"
                                                placeholder="Ej: Clientes que compran Frutas"
                                                value={this.state.cluster_name}
                                                onChange={this.onChangeClusterName}
                                                validations={[required]}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Código del Grupo</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="text"
                                                className="form-control"
                                                name="cluster_code"
                                                placeholder="Ej: FRUTAS_2025 (Opcional)"
                                                value={this.state.cluster_code}
                                                onChange={this.onChangeClusterCode}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Asignar Usuarios</label>
                                        <div className="col-md-7">
                                            <Select
                                                isMulti
                                                value={this.state.selectedUsers}
                                                onChange={this.handleUsersChange}
                                                options={this.state.allUsers}
                                                placeholder="Busca y selecciona usuarios..."
                                                noOptionsMessage={() => "No se encontraron usuarios"}
                                                isClearable={true}
                                                closeMenuOnSelect={false}
                                            />
                                            <small className="form-text text-muted">
                                                Opcional. Puedes seleccionar múltiples usuarios para asignarlos al grupo.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="pull-right">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={this.state.loading}
                                        >
                                            {this.state.loading && (
                                            <span className="spinner-border spinner-border-sm"></span>
                                            )}
                                            Guardar
                                        </button>
                                    </div>
                                    <CheckButton
                                        style={{ display: "none" }}
                                        ref={c => {
                                        this.checkBtn = c;
                                        }}
                                    />
                                </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </Fragment>
        )
    }
}

export default Ver_add_customer_cluster
